export const EMPLOYEE = '/employee/applicant/';
export const DOCUMENTS = '/employee/documents/';
